import React, { useEffect } from "react";
import rigbyHead from "../rigby-head.png";
import QuickReplies from "./QuickReplies";

// The conversation. Quick replies show under the newest bot message only while it is the last thing said.
export default function MessageList({ messages, isTyping, scrollRef, onPickChip, fileIcon }) {
  const last = messages[messages.length - 1];
  const chips = last && last.sender === "bot" && !isTyping ? last.chips : null;

  useEffect(() => {
    const el = scrollRef && scrollRef.current;
    if (el && typeof el.scrollTo === "function") el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
  }, [messages, isTyping, scrollRef]);

  return (
    <>
      <p className="rg-note">Rigby remembers this conversation</p>
      {messages.map((msg, idx) => (
        <div key={idx} className={`rg-row${msg.sender === "user" ? " is-user" : ""}`}>
          {msg.sender !== "user" && <img className="rg-small-mark" src={rigbyHead} alt="" />}
          <div className={`rg-bubble ${msg.sender === "user" ? "is-user" : "is-bot"}`}>
            {typeof msg.text === "string" ? msg.text : ""}
            {msg.files && msg.files.length > 0 && (
              <ul className="rg-files">
                {msg.files.map((f, i) => (
                  <li key={i}>
                    {fileIcon ? fileIcon(f && f.type) : null}
                    <span>{f && f.name != null ? String(f.name) : "File"}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      ))}
      {chips && <QuickReplies chips={chips} onPick={onPickChip} />}
      {isTyping && (
        <div className="rg-row" aria-live="polite">
          <img className="rg-small-mark" src={rigbyHead} alt="" />
          <div className="rg-bubble is-bot rg-typing" role="status" aria-label="Rigby is typing">
            <span />
            <span />
            <span />
          </div>
        </div>
      )}
    </>
  );
}
